import React from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import DatePicker from "react-multi-date-picker";
// import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
const DatePickerFormat = ({
  name,
  label,
  control,
  options,
  placeholder,
  errors,
  onChange,
  className
}) => {
  return (
 
    <Form.Group className={`${className}? ${className}: mb-3 w-75 `}>
    <Form.Label className="fw-bold pb-1">{label}</Form.Label>
    <Controller
      control={control}
      name={name}
      rules={{ required: true }} //optional
      render={({ field }) => (
        <>
          <DatePicker
            className="txt-center"
            {...field}
            onChange={(date)=> {
              field.onChange(date)
              onChange && onChange(date)
            }}
            format={"YYYY-MM-DD"}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            defaultValue={"1996-12-02T12:01:39.860Z"}
          />
          {errors?.name && <span> {label}الزامی است</span>}
        </>
      )}
    />
  </Form.Group>
  );
};

export default DatePickerFormat;
